import {
  DefaultTierDisplayName,
  SubscriptionPeriod,
  SubscriptionTier,
  SubscriptionTierDisplayNames,
  SubscriptionType,
} from "../../types";

export const getTierDisplayName = (tier: SubscriptionTier): string =>
  SubscriptionTierDisplayNames[tier] ?? DefaultTierDisplayName;

export const getPlanDisplayName = (
  type: SubscriptionType,
  subscriptionPeriod: SubscriptionPeriod,
  tier: SubscriptionTier,
  teamName?: string
): string => {
  if (
    type === SubscriptionType.Paddle ||
    type === SubscriptionType.Chargebee ||
    type === SubscriptionType.AppStore
  ) {
    const periodName =
      subscriptionPeriod === SubscriptionPeriod.Yearly ? "Billed annually" : "Billed monthly";
    return `Shapr3D ${tier ? getTierDisplayName(tier) + " - " : ""}${periodName}`;
  }

  switch (type) {
    case "edu":
      return "EDU - Valid for 1 year";
    case "gift":
      return "Gift";
    case "team":
      return `Team - Annual plan - You are a member of ${teamName}`;
  }

  return "N/A";
};

export const getSourceDisplayName = (source: string): string => {
  switch (source) {
    case "appstore":
      return "App Store";
    case "team":
    case "paddle":
    case "chargebee":
      return "Shapr3D Website";
    case "edu":
      return "Edu application";
    case "gift":
      return "Gift licence";
  }

  return "N/A";
};

export const formatExpirationDate = (expiration: string): string => {
  return new Date(expiration).toLocaleDateString("en-us", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });
};
